import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6746f22b099e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de6746f22b099e/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de6746f22b099e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6746f22b099e/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6746f22b099e/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/sections/InternalLinksSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de6746f22b099e/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de6746f22b099e/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8de6746f22b099e/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabletCaseStudy"] */ "/tmp/8de6746f22b099e/components/sections/TabletCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabletShowcase"] */ "/tmp/8de6746f22b099e/components/sections/TabletShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de6746f22b099e/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/node_modules/next/dist/client/link.js");
